import { ExternalLink } from 'lucide-react'
import { getToken } from '@/lib/auth'

// Galaxy (3D topology view) lives at its own separate Pages project
// Dashboard lives at ops-bridge-dashboard.pages.dev
// These are different domains so the iframe does not self-embed
const GALAXY_URL = 'https://ops-bridge-galaxy.pages.dev'

export function CommandCentrePanel() {
  // Safety guard: if we're already inside an iframe, don't render another
  // (prevents the Galaxy app from embedding the dashboard, which embeds Galaxy, infinitely)
  const isInIframe = (() => { try { return window.self !== window.top } catch { return true } })()
  const src = `${GALAXY_URL}?token=${encodeURIComponent(getToken())}`

  if (isInIframe) {
    return (
      <div className="flex flex-col items-center justify-center h-64 gap-4 text-text-muted">
        <div className="text-sm font-medium">Command Centre</div>
        <a
          href={src}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 px-3 py-2 rounded-md bg-accent/10 border border-accent/20 text-accent text-xs font-medium hover:bg-accent/20 transition-colors"
        >
          <ExternalLink className="h-3.5 w-3.5" />
          Open Galaxy View
        </a>
      </div>
    )
  }

  return (
    <div className="relative h-full w-full bg-[#020408]">
      <iframe
        src={src}
        className="w-full h-full border-0"
        title="Galaxy View — OpsBridge Topology"
        allow="accelerometer; gyroscope"
      />
    </div>
  )
}
